var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoTest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#78849e;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.688,22.375a5.688,5.688,0,1,1,5.688-5.687A5.694,5.694,0,0,1,16.688,22.375Zm0-10.5A4.813,4.813,0,1,0,21.5,16.688,4.818,4.818,0,0,0,16.688,11.875Z",
    transform: "translate(-1.375 -1.375)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.188,19.125a.438.438,0,0,1-.437-.437v-.23a2.766,2.766,0,0,1,1.213-2.21,1.313,1.313,0,1,0-2.088-1.06.438.438,0,0,1-.875,0,2.188,2.188,0,1,1,3.48,1.766,1.92,1.92,0,0,0-.855,1.5v.23a.438.438,0,0,1-.437.438Z",
    transform: "translate(-1.875 -1.625)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.438,21.875A.449.449,0,0,1,17,21.438a.355.355,0,0,1,.035-.166.311.311,0,0,1,.1-.14.3.3,0,0,1,.14-.1.434.434,0,0,1,.472.1.41.41,0,0,1,.131.306.373.373,0,0,1-.035.165.306.306,0,0,1-.1.14.408.408,0,0,1-.306.132Z",
    transform: "translate(-2.125 -2.625)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.313,18.75H2.188A2.19,2.19,0,0,1,0,16.563V5.188A2.19,2.19,0,0,1,2.188,3h1.75a.438.438,0,0,1,0,.875H2.188A1.314,1.314,0,0,0,.875,5.188V16.563a1.314,1.314,0,0,0,1.313,1.313H8.313a.438.438,0,0,1,0,.875Z",
    transform: "translate(0 -0.375)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.563,5.25H5.313A1.314,1.314,0,0,1,4,3.938V2.188a.438.438,0,0,1,.438-.437H5.794a2.188,2.188,0,0,1,4.287,0h1.356a.438.438,0,0,1,.438.438v1.75A1.314,1.314,0,0,1,10.563,5.25ZM4.875,2.625V3.938a.438.438,0,0,0,.438.438h5.25A.438.438,0,0,0,11,3.938V2.625H9.688a.438.438,0,0,1-.437-.437,1.313,1.313,0,0,0-2.625,0,.438.438,0,0,1-.437.438Z",
    transform: "translate(-0.5)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.188,8.875H3.438a.438.438,0,0,1,0-.875h8.75a.438.438,0,0,1,0,.875Z",
    transform: "translate(-0.375 -1)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.563,11.875H3.438a.438.438,0,0,1,0-.875H9.563a.438.438,0,0,1,0,.875Z",
    transform: "translate(-0.375 -1.375)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.813,14.875H3.438a.438.438,0,0,1,0-.875H7.813a.438.438,0,0,1,0,.875Z",
    transform: "translate(-0.375 -1.75)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.938,8.25a.438.438,0,0,1-.437-.437V5.188a1.314,1.314,0,0,0-1.312-1.312h-1.75a.438.438,0,0,1,0-.875h1.75a2.19,2.19,0,0,1,2.188,2.188V7.813A.438.438,0,0,1,15.938,8.25Z",
    transform: "translate(-1.5 -0.375)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTest);
export default __webpack_public_path__ + "static/media/ico_test.dbd1034d27d8747c66c340c49436c0be.svg";
export { ForwardRef as ReactComponent };